import { Box, Center, Input } from "@chakra-ui/react";
import * as Styled from "./searchBox.style";
import { type SearchBoxProps } from "./searchBox.type";

export const SearchBox = ({ keyword, position, ...rest }: SearchBoxProps) => {
    const { setKeyword, setPosition, setMarkers } = rest;

    const handleSearch = () => {
        const ps = new kakao.maps.services.Places();

        ps.keywordSearch(keyword, (data, status) => {
            if (status === window.kakao.maps.services.Status.OK) {
                const newMarkers = data.map((result: kakao.maps.services.PlacesSearchResultItem) => ({
                    store: result,
                    latLng: {
                        lat: parseFloat(result.y),
                        lng: parseFloat(result.x),
                    },
                }));

                setPosition(newMarkers.length > 0 ? newMarkers[0].latLng : position);
                setMarkers(newMarkers);
            }
        });
    };

    return (
        <Center position="relative" w="100%">
            <Box
                as="span"
                position="absolute"
                zIndex="9999"
                top="50%"
                left="0"
                p="0 12px"
                transform="translateY(-50%)"
                className="material-icons"
            >
                search
            </Box>
            <Input
                value={keyword}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setKeyword(e.target.value)}
                onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => e.key === "Enter" && handleSearch()}
                placeholder="검색어를 입력하세요."
                background="white"
                pl="40px"
            />
            <Styled.DeleteKeywordButton onClick={() => setKeyword("")}>
                <Box as="span" className="material-icons">
                    close
                </Box>
            </Styled.DeleteKeywordButton>
        </Center>
    );
};
